import { AddressFeatureState } from '../../../../../../../@types/state-types'
import { ContentStateInterface, GeoCoordinates } from '../../../../../../../@types/types'
import initialState from '../../../../../../../redux/reducers/root/initialState'
import { hasUsableGeoCoordinates } from '../../../../../../../utils/geo-utils'
import invariant from '../../../../../../../utils/invariant'

export const geoCoordinatesToApi = (
  addressFeature: AddressFeatureState,
  insertionData: ContentStateInterface
): GeoCoordinates => {
  const { geoCoordinates, hasValidGeoCoordinates } = addressFeature
  const { geoCoordinates: initialGeoCoordinates } = initialState.addressFeature
  const manualGeoCoordinates = insertionData.manualQuarter?.geoCoordinates
    ? insertionData.manualQuarter.geoCoordinates
    : initialGeoCoordinates
  const coordinates = hasValidGeoCoordinates ? geoCoordinates : manualGeoCoordinates

  invariant(hasUsableGeoCoordinates(coordinates), 'National address requires usable geo coordinates')
  return coordinates
}
